export default (creds) => {
  const promise = new Promise((resolve, reject) => {
    creds
      .delete(`/coupons/${creds.id}`)
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
  });
  return promise;
};
